import React from "react";
import styles from "./ModalErrorFallback.module.css";

/**
 * Compact fallback when a modal throws: message + Close button.
 * Used by ModalContainer inside ErrorBoundary.
 */
export const ModalErrorFallback = ({ error, onClose }) => (
  <div className={styles.container}>
    <p className={styles.message}>Something went wrong.</p>
    <pre className={styles.pre}>{error}</pre>
    <button type="button" onClick={onClose} className={styles.closeButton}>
      Close
    </button>
  </div>
);

export default ModalErrorFallback;
